import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import PaymentProvidersView from "@/views/PaymentProvidersView.vue";
import { trackRouter } from "vue-gtag-next";
import OtherAmountEntryView from "@/views/OtherAmountEntryView.vue";
import SuperPacmanInstallmentsView from "@/views/SuperPacmanInstallmentsView.vue";
import PaymentSuccessView from "@/views/PaymentSuccessView.vue";
import PaymentFailedView from "@/views/PaymentFailedView.vue";
import ExtensionTypeView from "@/views/ExtensionTypeView.vue";
import ExtensionReasonView from "@/views/ExtensionReasonView.vue";
import V1InstallmentsView from "@/views/V1InstallmentsView.vue";
import V1PaymentProvidersView from "@/views/V1PaymentProvidersView.vue";
import V1ProviderGroupView from "@/views/V1ProviderGroupView.vue";
import V1OtherAmountView from "@/views/V1OtherAmountView.vue";
import V1PaymentReferenceView from "@/views/V1PaymentReferenceView.vue";
import { ensureV1DevAuth } from "@/helpers/v1TestHelper";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "root",
    component: () => import("@/components/HelloI18n.vue"),
    props: true,
  },
  {
    path: "/version",
    name: "Version",
    component: () => import("@/components/HelloI18n.vue"),
  },
  {
    // INC-2543: the Phone Finance UI is retired; existing /device links continue in Super Pacman.
    path: "/device/:deviceTag",
    redirect: (to) => ({ name: "SuperPacmanInstallments", params: to.params, query: to.query }),
  },
  {
    path: "/providers/",
    name: "ProvidersByDeviceTagAndCountry",
    component: PaymentProvidersView,
    props: true,
  },
  {
    path: "/views/:providerName",
    name: "DynamicProviderLoader",
    component: () => import("@/views/DynamicProviderLoaderView.vue"),
  },
  {
    path: "/other-amount",
    name: "OtherAmountView",
    component: OtherAmountEntryView,
  },
  {
    path: "/p/device/:deviceTag",
    name: "SuperPacmanInstallments",
    component: SuperPacmanInstallmentsView,
  },
  {
    path: "/payment-success",
    name: "PaymentSuccessView",
    component: PaymentSuccessView,
  },
  {
    path: "/payment-failed",
    name: "PaymentFailedView",
    component: PaymentFailedView,
  },
  {
    path: "/extensions/device/:deviceTag",
    name: "ExtensionTypeView",
    component: ExtensionTypeView,
    meta: { ownsHeader: true },
  },
  {
    path: "/extension-reason",
    name: "ExtensionReasonView",
    component: ExtensionReasonView,
    meta: { ownsHeader: true },
  },
  {
    path: "/v1/device/:deviceTag",
    name: "V1InstallmentsByDevice",
    component: V1InstallmentsView,
    props: true,
    beforeEnter: async (to) => await ensureV1DevAuth(to.params.deviceTag as string),
  },
  {
    path: "/v1/device/:deviceTag/providers",
    name: "V1ProvidersByDevice",
    component: V1PaymentProvidersView,
    props: true,
    beforeEnter: async (to) => await ensureV1DevAuth(to.params.deviceTag as string),
  },
  {
    path: "/v1/device/:deviceTag/providers/:groupId",
    name: "V1ProviderGroupByDevice",
    component: V1ProviderGroupView,
    props: true,
    beforeEnter: async (to) => await ensureV1DevAuth(to.params.deviceTag as string),
  },
  {
    path: "/v1/device/:deviceTag/other-amount",
    name: "V1OtherAmountByDevice",
    component: V1OtherAmountView,
    props: true,
    beforeEnter: async (to) => await ensureV1DevAuth(to.params.deviceTag as string),
  },
  {
    path: "/v1/device/:deviceTag/reference",
    name: "V1PaymentReferenceByDevice",
    component: V1PaymentReferenceView,
    props: true,
    beforeEnter: async (to) => await ensureV1DevAuth(to.params.deviceTag as string),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

trackRouter(router);

export default router;
